import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import "../CodingScreen/CodingScreen.css";
import confirm_tick from "../../common/assets/images/confirm.png";
import code_assist from "../../common/assets/images/codebook.png";
import { toast } from "react-toastify";
import { Loader } from "../../utils/Loader";
import { CodeContext } from "../pages/Coder/Coder";
import { debounce } from "lodash";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import code_assist_seacrh from "../../common/assets/images/search-1.png";
import stars_icon from "../../common/assets/images/stars-01.png";
import { checkHAC, codeReccomendations } from "./Service";
import { getErrorMessage } from "./utils";
import DraggableItem from "./DraggableItem";
import { useLazyGetData2Query } from "../../store/apiSlice";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Warnings from "./Warnings";
import DrgInfo from "./DrgInfo";
import WarningModal from "./WarningModal";
import VentilationInfo from "./VentilationInfo";
import {
  setOnChangeCodeBook,
  setRawSearchQuery,
  updateAcsCode,
} from "../CodeBook/redux/CodeBookSlicer";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  getFilterEpisodeLists,
  selectedEpisodeList,
} from "../pages/EpisodeList/redux/EpisodeListSlicer";
import { useDispatch } from "react-redux";

const CodingScreen = ({
  drgData,
  setDrgData,
  codingscreendata,
  episodeListData,
  setCodeBookCard,
  setReimbursementValue,
  setAccepted,
  diagnosisStates,
  setDiagnosisStates,
  setTrackHistory,
  setRedoStack,
  setShowCodeSearch,
  skipAcceptApi,
  acceptedCodes,
  setAcceptedCodes,
  calculate_drg,
  handleConfirmDrg,
  drgConfirmedStatusUpdate,
  isDrgConfirmed,
  setEnableFinalize,
  enableFinalize,
  setAuditedStatus,
  auditedStatus,
  handleCodeAssistAdding,
  validateCodeAPI,
  insertCode,
  handleAccept,
  saveToHistory,
  iconDisplay,
  setIconDispaly,
  warningMessage,
  setWarningMessage,
  newlyInsertedCodes,
  setNewlyInsertedCodes,
  pendingCode,
  pendingType,
  setPendingCode,
  setPendingType,
  modalVisible,
  setModalVisible,
  modalMessage,
  setModalMessage,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const {
    setSelectedCodeBookCode,
    setSelectedTabKeyCoding,
    setDrgLoading,
    drgloading,
  } = useContext(CodeContext);
  const [enteredCode, setEnteredCode] = useState({
    principalCode: "",
    additionalCode: "",
    procedureCode: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    principal: "",
    additional: "",
    procedure: "",
  });
  // const [stopDropCall,setStopDrop]=useState(false);
  const [searchBy, setSearchBy] = useState("");
  const dispatch = useDispatch();
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;

  const codebookinternalEnv = process.env.REACT_APP_FLAG_INTERNAL;
  const codebooknmhsEnv = process.env.REACT_APP_FLAG_NMHS;

  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const pallasaiTestCodebookEnv = process.env.REACT_APP_FLAG_PALLASAI_TEST;
  const codebookfigiEnv = process.env.REACT_APP_FLAG_FIJI_DEV;
  const codebooksanhcEnv = process.env.REACT_APP_FLAG_SAN_HC

  const predefinedProcedureCodes = [
    "18216-27",
    "18216-00",
    "18216-29",
    "18216-09",
    "18216-31",
    "18216-18",
    "18234-00",
    "18236-00",
    "18238-00",
    "18240-00",
    "18244-00",
    "18246-00",
    "18250-00",
    "90023-00",
    "39013-02",
    "18280-00",
    "18282-00",
    "18288-00",
    "18288-01",
    "18284-00",
    "18286-00",
    "18286-01",
    "18286-02",
    "92506-10",
    "92506-19",
    "92506-20",
    "92506-29",
    "92506-30",
    "92506-39",
    "92506-40",
    "92506-49",
    "92506-50",
    "92506-59",
    "92506-69",
    "92506-90",
    "92506-99",
    "92507-10",
    "92507-19",
    "92507-20",
    "92507-29",
    "92507-30",
    "92507-39",
    "92507-40",
    "92507-49",
    "92507-50",
    "92507-59",
    "92507-69",
    "92507-90",
    "92507-99",
    "92500-00",
    "92500-01",
    "92500-02",
    "92508-10",
    "92508-19",
    "92508-20",
    "92508-29",
    "92508-30",
    "92508-39",
    "92508-40",
    "92508-49",
    "92508-50",
    "92508-59",
    "92508-69",
    "92508-90",
    "92508-99",
    "92509-10",
    "92509-19",
    "92509-20",
    "92509-29",
    "92509-30",
    "92509-39",
    "92509-40",
    "92509-49",
    "92509-50",
    "92509-59",
    "92509-69",
    "92509-90",
    "92509-99",
    "92510-10",
    "92510-19",
    "92510-20",
    "92510-29",
    "92510-30",
    "92510-39",
    "92510-40",
    "92510-49",
    "92510-50",
    "92510-59",
    "92510-69",
    "92510-90",
    "92510-99",
    "92511-10",
    "92511-19",
    "92511-20",
    "92511-29",
    "92511-30",
    "92511-39",
    "92511-40",
    "92511-49",
    "92511-50",
    "92511-59",
    "92511-69",
    "92511-90",
    "92511-99",
    "92512-10",
    "92512-19",
    "92512-20",
    "92512-29",
    "92512-30",
    "92512-39",
    "92512-40",
    "92512-49",
    "92512-50",
    "92512-59",
    "92512-69",
    "92512-90",
    "92512-99",
    "92519-10",
    "92519-19",
    "92519-20",
    "92519-29",
    "92519-30",
    "92519-39",
    "92519-40",
    "92519-49",
    "92519-50",
    "92519-59",
    "92519-69",
    "92519-90",
    "92519-99",
    "92513-10",
    "92513-19",
    "92513-20",
    "92513-29",
    "92513-30",
    "92513-39",
    "92513-40",
    "92513-49",
    "92513-50",
    "92513-59",
    "92513-69",
    "92513-90",
    "92513-99",
    "92514-10",
    "92514-19",
    "92514-20",
    "92514-29",
    "92514-30",
    "92514-39",
    "92514-40",
    "92514-49",
    "92514-50",
    "92514-59",
    "92514-69",
    "92514-90",
    "92514-99",
    "92515-10",
    "92515-19",
    "92515-20",
    "92515-29",
    "92515-30",
    "92515-39",
    "92515-40",
    "92515-49",
    "92515-50",
    "92515-59",
    "92515-69",
    "92515-90",
    "92515-99",
  ];
  const lastCodedEpisode = useSelector((state) => state.episodeList);
  const { drgValue, weightValue, accepted } = useContext(CodeContext);
  // const [newlyInsertedCodes, setNewlyInsertedCodes] = useState([]);
  const [searchOptionsDropdown, setSearchOptionsDropdown] = useState(false);
  // const diagnosisStates = useSelector(
  //   (state) => state.codingScreen.diagnosisStates
  // );
  const finalcode = localStorage.getItem("finalCode");
  // const [modalVisible, setModalVisible] = useState(false);
  // const [modalMessage, setModalMessage] = useState("");
  // const [pendingCode, setPendingCode] = useState(null);
  // const [pendingType, setPendingType] = useState(null);
  // const [warningMessage, setWarningMessage] = useState();
  const [hacStatus, setHACStatus] = useState({});
  const [hasCode, setHasCode] = useState(false);
  const [
    fetchData1,
    {
      data: data1,
      isLoading: isLoading1,
      isFetching: isFetching1,
      error: error1,
    },
  ] = useLazyGetData2Query();
  const [skipAPI, setSkipAPI] = useState(false);
  // const [iconDisplay, setIconDispaly] = useState(true);
  const [isAnimation, setIsAnimation] = useState(false);
  const [recommendations, setRecommendations] = useState([]);
  const [lastHcpLineId, setHcpLineId] = useState(
    localStorage.getItem("last_hcp_line_id")
  );
  const navigate = useNavigate();
  let controller = new AbortController();
  const [hasPrincipalHAC, setHasPrincipalHAC] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const location = useLocation();
  const fromLocation = location.state?.from;
  const dropdownRef = useRef(null);
  const inputRefList = useRef({});
  const searchOptionsRef = useRef(null);
  const allCodes = [
    ...(codingscreendata?.data?.procedure_codes || []),
    ...(codingscreendata?.data?.additional_diagnoses || []),
    ...(codingscreendata?.data?.principal_diagnosis || []),
  ];
  // console.log(codingscreendata, "pp");

  // Filter only AI-origin codes
  const aiCodes = allCodes.filter((code) => code.origin === "AI");
  // const allOriginsAreAU = allCodes.every((item) => item.origin === "AU");

  // Check if all AI-origin codes are accepted
  const allCodesAccepted =
    aiCodes.length > 0 &&
    aiCodes.every((code) => !!(acceptedCodes?.[code.code.trim()] ?? false));
  const allOriginsAreU = allCodes.every(
    (item) =>
      item.origin === "U" ||
      item.origin === "AU" ||
      item.origin === "P" ||
      ((codingscreendata?.data?.meta?.status === "Coding Complete" ||
        codingscreendata?.data?.meta?.status === "Audited") &&
        item.origin === "AI")
  );
  const [selectedCofValues, setSelectedCofValues] = useState({});
  const isButtonEnabled = allCodesAccepted;

  const checkCofWarnings = (codingscreendata) => {
    if (!codingscreendata || !codingscreendata.data) return;

    const { principal_diagnosis, additional_diagnoses, procedure_codes } =
      codingscreendata.data;
    const allCodes = [
      ...(principal_diagnosis || []),
      ...(additional_diagnoses || []),
      ...(procedure_codes || []),
    ];

    let hasCofWarning = false;
    const updatedHacStatus = {}; // Store HAC status with normalized keys

    allCodes.forEach((item) => {
      if (item?.code?.startsWith("1") && item.cof_warning === true) {
        hasCofWarning = true;
        const normalizedCode = item.code.slice(1); // Remove first character
        updatedHacStatus[normalizedCode] = true; // Store in hacStatus
      }
    });

    // Update state once after all checks
    setHACStatus(updatedHacStatus);
    setHasCode(hasCofWarning);
  };
  // useEffect(() => {
  //   if (diagnosisStates?.procedure?.length > 0) {
  //     const updatedProcedure = [...diagnosisStates.procedure];

  //     const itemsToMove = [];
  //     const remainingItems = [];

  //     updatedProcedure.forEach((item) => {
  //       const rawCode = item.code;
  //       const cleanCode = rawCode.split("[")[0].trim();

  //       if (predefinedProcedureCodes.includes(cleanCode)) {
  //         itemsToMove.push(item);
  //       } else {
  //         remainingItems.push(item);
  //       }
  //     });

  //     const reorderedProcedure = [...remainingItems, ...itemsToMove];

  //     // Avoid infinite loop — only update if something changed
  //     const codesBefore = updatedProcedure.map((i) => i.code).join(",");
  //     const codesAfter = reorderedProcedure.map((i) => i.code).join(",");

  //     if (codesBefore !== codesAfter) {
  //       setDiagnosisStates((prev) => ({
  //         ...prev,
  //         procedure: reorderedProcedure,
  //       }));
  //     }
  //   }
  // }, [diagnosisStates.procedure]);

  const fetchRecommendations = useCallback(
    debounce(async (payload) => {
      console.log(payload, "kjhgfh");
      if (
        (payload.code && !payload.code.trim()) ||
        (payload.description && !payload.description.trim())
      ) {
        setRecommendations([]);
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      setIsLoading(true);
      try {
        const response = await codeReccomendations(payload, controller.signal);
        if (response) {
          setRecommendations(response.data);
          setShowDropdown(true);
        }
      } catch (error) {
        console.error("Error fetching recommendations:", error);
      } finally {
        setIsLoading(false);
      }
    }, 100),
    []
  );
  // console.log(searchBy, "searchBy");
  // console.log(searchBy, "changeby");

  const handleCodeChange = (e, type, searchBy) => {
    console.log(searchBy, "changeby");

    const finalCodeKey = searchBy === "Code" ? "code" : "description";
    const { name, value } = e.target;

    setActiveSection(type);
    setEnteredCode((prev) => ({ ...prev, [name]: value }));

    if (value.trim() === "") {
      setActiveSection(null);
      setErrorMessage((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    // Determine coding system
    let checkType;
    if (type === "additional" || type === "principal") {
      checkType = "ICD";
    } else {
      checkType =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        pallasaiTestCodebookEnv ||codebooksanhcEnv||
        codebookfigiEnv
          ? "ACHI"
          : codebookusaEnv
          ? "CPT"
          : "";
    }

    // Dynamically construct payload with key `code` or `description`
    const payload = {
      [finalCodeKey]: value,
      check_for: checkType,
      similarity: false,
    };

    fetchRecommendations(payload);
  };

  // const validateCodeAPI = async (code, type) => {
  //   // console.log(type, codebookdevEnv, "mhsgcjhs");
  //   if (type === "additional" || type === "principal") {
  //     type = "ICD";
  //   } else {
  //     type =
  //       codebookdevEnv ||
  //       codebookinternalEnv ||
  //       codebookcoblhEnv ||
  //       codebooknmhsEnv ||
  //       codebooksanEnv||pallasaiTestCodebookEnv || codebookfigiEnv
  //         ? "ACHI"
  //         : codebookusaEnv
  //         ? "CPT"
  //         : "";
  //   }
  //   const url = "/checkIfCodeExists";
  //   const payload = {
  //     u_agey: codingscreendata?.data?.meta?.age_y,
  //     u_aged: codingscreendata?.data?.meta?.age_d,
  //     sex: codingscreendata?.data?.meta?.sex,
  //     code: code,
  //     check_for: type,
  //   };
  //   try {
  //     const response = await axiosInstance.post(url, payload);
  //     if (response.status === 200) {
  //       return {
  //         valid: response.data.code_exists,
  //         description: response.data.description || "",
  //         isWarning: response.data.is_warning || false,
  //         warningDescription: response.data.warning_description || "",
  //         isPopup: response.data.should_popup,
  //       };
  //     }
  //   } catch (error) {
  //     console.error("Error validating code", error);
  //   }
  //   return {
  //     valid: false,
  //     description: "",
  //     isWarning: false,
  //     warningDescription: "",
  //     isPopup: "",
  //   };
  // };

  const insertingCodes = new Set();
  // const insertCode = async (code, description, type, warning) => {
  //   if (insertingCodes.has(code)) {
  //     // console.warn(`Skipping duplicate insertion for: ${code}`);
  //     return;
  //   }
  //   insertingCodes.add(code);
  //   return new Promise((resolve) => {
  //     setDiagnosisStates((prev) => {
  //       if (prev[type].some((item) => item.code === code)) {
  //         insertingCodes.delete(code);
  //         //console.warn(`Code already exists in ${type}, skipping: ${code}`);
  //         return prev;
  //       }
  //       const newCode = {
  //         code,
  //         description: description || `Description for ${code}`,
  //         warning,
  //       };
  //       const updatedState = {
  //         ...prev,
  //         [type]: type === "principal" ? [newCode] : [...prev[type], newCode],
  //       };
  //       localStorage.setItem(
  //         `${type}DiagnosisState`,
  //         JSON.stringify(updatedState[type])
  //       );
  //       return updatedState;
  //     });
  //     setTimeout(() => {
  //       setDiagnosisStates((updatedState) => {
  //         handleAccept(code, { code, description, warning }, type, updatedState)
  //           .then(() => insertingCodes.delete(code))
  //           .catch(() => insertingCodes.delete(code));
  //         return updatedState;
  //       });
  //       resolve();
  //     }, 0);
  //   });
  // };
  // const saveToHistory = () => {
  //   setTrackHistory((prev) => [
  //     ...prev,
  //     cloneDeep({ diagnosisStates, acceptedCodes }),
  //   ]);
  //   setRedoStack([]);
  // };

  const isCodeRestricted = (code) => {
    return /^M.*\/\d$/.test(code);
  };
  const handleCodeInsertion = async (inputValue, type) => {
    setActiveSection(null);
    setIsAnimation(true);
    setAuditedStatus(true);
    try {
      if (!inputValue || (Array.isArray(inputValue) && inputValue.length === 0))
        return;
      if (Array.isArray(inputValue)) {
        inputValue = inputValue.join(", ");
      }

      const isSpecialPattern = inputValue.trim().startsWith("(");

      let extractedCodes = [];

      const match = inputValue.trim().match(/^\(([^)]+)\)([^,]+)(?:,(.+))?$/);
      if (match) {
        const codeInsideParens = match[1].trim();
        const firstCode = match[2].trim();
        const remainingCodes = match[3]
          ? match[3]
              .split(",")
              .map((c) => c.trim())
              .filter(Boolean)
          : [];

        extractedCodes = [firstCode, codeInsideParens, ...remainingCodes];
      } else {
        extractedCodes = inputValue
          .split(",")
          .map((code) => code.trim())
          .filter(Boolean);
      }

      // Remove duplicates
      extractedCodes = [...new Set(extractedCodes)];
      if (extractedCodes.length === 0) return;

      // **Filter out restricted codes here**
      const filteredCodes = extractedCodes.filter((code) => {
        if (isCodeRestricted(code)) {
          // toast.warning(`Code ${code} is not allowed.`);
          return false;
        }
        return true;
      });

      if (filteredCodes.length === 0) {
        toast.warning("No valid codes to insert!");
        return;
      }

      let principalCode = filteredCodes[0];
      let additionalCodes = filteredCodes.slice(1);
      let prevPrincipal = diagnosisStates["principal"][0];

      const existingCodes = new Set([
        ...diagnosisStates["principal"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["additional"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["procedure"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
      ]);

      let validCodes = [];
      let principalWarnings = [];
      let additionalWarnings = [];

      const validationResults = await Promise.all(
        filteredCodes.map(async (code) => {
          const validationType =
            type === "procedure"
              ? "procedure"
              : code === principalCode && type === "principal"
              ? "principal"
              : "additional";

          const { valid, description, isWarning, warningDescription, isPopup } =
            await validateCodeAPI(code, validationType);

          if (!valid) return null;

          const warning = {
            is_warning: isWarning,
            should_popup: isPopup,
            warning_description: warningDescription,
          };

          if (isWarning && warningDescription) {
            if (validationType === "principal") {
              principalWarnings.push(warningDescription);
            } else {
              additionalWarnings.push(warningDescription);
            }
          }

          return { code, description, warning, validationType };
        })
      );

      validCodes = validationResults.filter(Boolean);
      if (validCodes.length === 0) {
        toast.warning("No valid new codes to insert!");
        return;
      }

      const newValidCodes = validCodes.filter(({ code }) => {
        const normalizedCode = code.replace(/^[12]/, "");
        if (existingCodes.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      if (newValidCodes.length === 0) {
        // toast.warning("No new codes to insert after checking existing codes!");
        return;
      }

      saveToHistory();
      const orderedValidCodes =
        type === "principal" ? [...newValidCodes].reverse() : newValidCodes;

      setDiagnosisStates((prevStates) => {
        let updatedStates = {
          principal: [...prevStates["principal"]],
          additional: [...prevStates["additional"]],
          procedure: [...prevStates["procedure"]],
        };

        if (type === "principal") {
          const principalEntry = newValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, "")
          );

          if (
            prevPrincipal?.code &&
            principalEntry &&
            prevPrincipal?.code?.replace(/^[12]/, "") !==
              principalEntry?.code?.replace(/^[12]/, "") &&
            !updatedStates["additional"].some(
              (item) =>
                item?.code?.replace(/^[12]/, "") ===
                prevPrincipal?.code?.replace(/^[12]/, "")
            )
          ) {
            updatedStates["additional"] = [
              prevPrincipal,
              ...updatedStates["additional"],
            ];
          }

          if (principalEntry) {
            updatedStates["principal"] = [
              { ...principalEntry, code: `2${principalEntry.code}` },
            ];
          }
        }

        orderedValidCodes.forEach(
          ({ code, description, warning, validationType }) => {
            const normalizedCode = code.replace(/^[12]/, "");
            const alreadyExistsInAdditional = updatedStates["additional"].some(
              (item) => item?.code?.replace(/^[12]/, "") === normalizedCode
            );
            const alreadyExistsInPrincipal = updatedStates["principal"].some(
              (item) => item?.code?.replace(/^[12]/, "") === normalizedCode
            );

            if (!alreadyExistsInAdditional && !alreadyExistsInPrincipal) {
              const prefixedCode =
                validationType !== "procedure" ? `2${code}` : code;
              insertCode(prefixedCode, description, validationType, warning);
              const newEntry = {
                code: prefixedCode,
                description,
                warning,
              };

              if (validationType === "additional") {
                if (type === "principal") {
                  updatedStates["additional"].unshift(newEntry);
                } else {
                  updatedStates["additional"].push(newEntry);
                }
              }
            }
          }
        );

        return updatedStates;
      });

      setWarningMessage((prevWarnings) => {
        let updatedWarnings = [...prevWarnings];
        const currentPrincipalWarnings = new Set(
          diagnosisStates["principal"]
            .filter((item) => item.warning?.is_warning)
            .map((item) => item.warning.warning_description)
        );
        const currentAdditionalWarnings = new Set(
          diagnosisStates["additional"]
            .filter((item) => item.warning?.is_warning)
            .map((item) => item.warning.warning_description)
        );

        updatedWarnings = updatedWarnings.filter(
          (msg) =>
            currentPrincipalWarnings.has(msg) ||
            currentAdditionalWarnings.has(msg)
        );

        principalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.unshift(warning);
          }
        });

        additionalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.push(warning);
          }
        });

        return updatedWarnings;
      });

      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...newValidCodes.map(({ code }) => code),
      ]);

      const lastInsertedCode = newValidCodes[newValidCodes.length - 1]?.code;
      const popupWarning = newValidCodes.find(
        ({ code, warning }) => code === lastInsertedCode && warning.should_popup
      );

      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.warning.warning_description);
        setModalVisible(true);
      }

      setEnteredCode((prev) => ({ ...prev, [type]: "" }));
    } catch (error) {
      console.log(error);
    } finally {
      setIsAnimation(false);
      // setAuditedStatus(false);
      const newEpisodeListFilterObj = localStorage.getItem("filters");
      const hcpLineId = localStorage.getItem("last_hcp_line_id");
      setTimeout(() => {
        dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {
          console.log(res, "drgclickres");

          const newEpisodeRecord = res.payload?.episode?.find(
            (episode) => episode?.hcp_line_id === Number(hcpLineId)
          );

          if (newEpisodeRecord) {
            dispatch(selectedEpisodeList(newEpisodeRecord));
          }
        });
      }, 300);
    }
  };

  const handleDrop = async (event, type) => {
    // setStopDrop(true);
    // console.log(type, "checktypenew");
    event.preventDefault();
    setIsAnimation(true);
    setAuditedStatus(true);
    try {
      let draggedData;
      try {
        draggedData = JSON.parse(
          event.dataTransfer.getData("application/json")
        );
      } catch (error) {
        toast.error("Invalid data format");
        return;
      }

      const { codes, tab } = draggedData;
      // console.log(draggedData, "draggedData");

      if (!codes || !Array.isArray(codes) || codes.length === 0) {
        toast.error("Invalid codes!");
        return;
      }
      const existingCodes = new Set([
        ...diagnosisStates["principal"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["additional"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["procedure"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
      ]);

      const isICD =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        pallasaiTestCodebookEnv ||codebooksanhcEnv||
        codebookfigiEnv
          ? tab.includes("ICD 10 AM")
          : codebookusaEnv
          ? tab.includes("ICD 10 CM")
          : false;
      const isACHI =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        pallasaiTestCodebookEnv ||codebooksanhcEnv||
        codebookfigiEnv
          ? tab.includes("ACHI")
          : codebookusaEnv
          ? tab.includes("CPT")
          : false;

      if (
        (type === "procedure" && isICD) ||
        ((type === "additional" || type === "principal") && isACHI)
      ) {
        type =
          codebookdevEnv ||
          codebookinternalEnv ||
          codebookcoblhEnv ||
          codebooknmhsEnv ||
          codebooksanEnv ||
          pallasaiTestCodebookEnv ||codebooksanhcEnv||
          codebookfigiEnv
            ? "ACHI"
            : codebookusaEnv
            ? "CPT"
            : "";
        toast.warning(
          `${
            isICD ? "ICD" : type
          } codes can't be inserted in ${type.toUpperCase()} section`
        );
        return;
      }

      let extractedCodesArray = [];
      codes.forEach((code) => {
        code = code.trim();
        if (!code) return;

        // Check if the entire code is wrapped in parentheses like (M800/1)
        if (/^\([^()]+\)$/.test(code)) {
          extractedCodesArray.push(code.slice(1, -1).trim()); // Remove outer parentheses
          return;
        }

        // Existing logic: check for format like (desc)code or code(desc)
        const match = code.match(/^\(([^)]+)\)(.+)$/);
        if (match) {
          extractedCodesArray.push(match[2].trim());
          extractedCodesArray.push(match[1].trim());
        } else {
          extractedCodesArray.push(code);
        }
      });
      let principalCode = extractedCodesArray[0];
      if (type === "principal" && isCodeRestricted(principalCode)) {
        toast.warning(
          `Code is restricted and cannot be added to the Principal section.`
        );
        return;
      }
      let additionalCodes = extractedCodesArray.slice(1);
      let prevPrincipal = diagnosisStates["principal"][0];
      // console.log("Extracted Principal:", principalCode);
      // console.log("Extracted Additional:", additionalCodes);
      let uniqueNewCodes = extractedCodesArray.filter(
        (code) => !existingCodes.has(code.replace(/^[12]/, ""))
      );

      if (uniqueNewCodes.length === 0) {
        toast.warning("Codes already exist!");
        return;
      }

      let finalValidCodes = [];
      let newPrincipalWarnings = [];
      let newAdditionalWarnings = [];
      let popupWarnings = [];

      const validationResults = await Promise.all(
        uniqueNewCodes.map(async (extractedCode) => {
          const validationType =
            extractedCode.replace(/^[12]/, "") ===
              principalCode.replace(/^[12]/, "") && type === "principal"
              ? "principal"
              : type === "procedure"
              ? "procedure"
              : "additional";

          const { valid, description, isWarning, warningDescription, isPopup } =
            await validateCodeAPI(extractedCode, validationType);

          if (!valid) return null;

          const warning = {
            is_warning: isWarning,
            should_popup: isPopup,
            warning_description: warningDescription,
          };

          if (isWarning && warningDescription) {
            if (validationType === "principal") {
              newPrincipalWarnings.push(warningDescription);
            } else {
              newAdditionalWarnings.push(warningDescription);
            }
          }

          if (isPopup) {
            popupWarnings.push({
              code: extractedCode,
              message: warningDescription,
            });
          }

          return { code: extractedCode, description, warning, validationType };
        })
      );

      finalValidCodes = validationResults.filter(Boolean);
      if (finalValidCodes.length === 0) {
        toast.warning("No valid new codes to insert!");
        return;
      }

      const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
        const normalizedCode = code.replace(/^[12]/, "");
        if (existingCodes.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });
      // console.log(
      //   "Non-Duplicate Valid Codes:",
      //   nonDuplicateValidCodes.map((c) => c.code)
      // );

      if (nonDuplicateValidCodes.length === 0) {
        toast.warning("Codes already exist!");
        return;
      }
      // console.log(nonDuplicateValidCodes, "nonDuplicateValidCodes");

      await Promise.all(
        nonDuplicateValidCodes.map(
          ({ code, description, warning, validationType }) => {
            if (type !== "principal") {
              return insertCode(
                validationType !== "procedure"
                  ? `2${code.replace(/^[12]/, "")}`
                  : code,
                description,
                validationType,
                warning
              );
            } else {
              return Promise.resolve(); // Avoid unhandled promises
            }
          }
        )
      );

      setIconDispaly(true);
      saveToHistory();
      // console.log(
      //   "Non-Duplicate Valid Codes:",
      //   nonDuplicateValidCodes.map((c) => c.code)
      // );
      // console.log("Extracted Additional Codes (Raw):", additionalCodes);

      setDiagnosisStates((prevStates) => {
        let updatedStates = { ...prevStates };

        if (type === "principal") {
          const principalEntry = nonDuplicateValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, "")
          );

          if (
            prevPrincipal?.code &&
            !prevStates["additional"].some(
              (item) =>
                item?.code?.replace(/^[12]/, "") ===
                prevPrincipal?.code?.replace(/^[12]/, "")
            )
          ) {
            updatedStates["additional"] = [
              prevPrincipal,
              ...prevStates["additional"],
            ];

            insertCode(
              `2${prevPrincipal?.code?.replace(/^[12]/, "")}`,
              prevPrincipal?.description,
              "additional",
              prevPrincipal.warning
            );
          }

          if (principalEntry) {
            updatedStates["principal"] = [
              {
                ...principalEntry,
                code: `2${principalEntry.code.replace(/^[12]/, "")}`,
              },
            ];
          }
        }

        const additionalEntries = nonDuplicateValidCodes.filter(({ code }) => {
          const normalized = code.replace(/^[12]/, "");
          return (
            additionalCodes.includes(normalized) &&
            normalized !== principalCode.replace(/^[12]/, "") &&
            !prevStates["additional"].some(
              (item) => item.code.replace(/^[12]/, "") === normalized
            )
          );
        });

        const additionalCodesNormalized = additionalCodes.map((code) =>
          code.replace(/^[12]/, "")
        );

        let reorderedAdditional = [];

        if (type === "principal") {
          const allTopCodes = [...additionalCodesNormalized];

          if (
            prevPrincipal &&
            !allTopCodes.includes(prevPrincipal?.code?.replace(/^[12]/, ""))
          ) {
            allTopCodes.push(prevPrincipal?.code?.replace(/^[12]/, ""));
          }

          reorderedAdditional = [
            ...allTopCodes
              .map((normalizedCode) => {
                const found = nonDuplicateValidCodes.find(
                  ({ code }) => code.replace(/^[12]/, "") === normalizedCode
                );
                if (found) {
                  return {
                    ...found,
                    code: `2${found.code.replace(/^[12]/, "")}`,
                  };
                }

                const existing = prevStates["additional"].find(
                  (item) => item.code.replace(/^[12]/, "") === normalizedCode
                );
                if (existing) return existing;

                if (
                  prevPrincipal?.code &&
                  prevPrincipal?.code?.replace(/^[12]/, "") === normalizedCode
                ) {
                  insertCode(
                    `2${prevPrincipal?.code?.replace(/^[12]/, "")}`,
                    prevPrincipal?.description,
                    "additional",
                    prevPrincipal?.warning
                  );
                  return {
                    ...prevPrincipal,
                    code: `2${prevPrincipal?.code?.replace(/^[12]/, "")}`,
                  };
                }

                return null;
              })
              .filter(Boolean),

            ...prevStates["additional"].filter(
              (item) => !allTopCodes.includes(item?.code?.replace(/^[12]/, ""))
            ),
          ];
        } else if (type === "additional") {
          const newCodesToAppend = additionalCodesNormalized
            .filter(
              (normalizedCode) =>
                !prevStates["additional"].some(
                  (item) => item?.code?.replace(/^[12]/, "") === normalizedCode
                )
            )
            .map((normalizedCode) => {
              const found = nonDuplicateValidCodes.find(
                ({ code }) => code?.replace(/^[12]/, "") === normalizedCode
              );
              if (found) {
                return {
                  ...found,
                  code: `2${found?.code?.replace(/^[12]/, "")}`,
                };
              }
              return null;
            })
            .filter(Boolean);

          reorderedAdditional = [
            ...prevStates["additional"],
            ...newCodesToAppend,
          ];
        }

        // Only update "additional" section if it's relevant to the drop type
        if (type === "principal" || type === "additional") {
          updatedStates["additional"] = reorderedAdditional;
        }

        // console.log(
        //   "Before Update - Additional State:",
        //   prevStates["additional"].map((a) => a.code)
        // );
        // console.log(
        //   "Additional Entries to Add at Top:",
        //   additionalEntries.map((a) => a.code)
        // );
        // console.log(
        //   "After Update - Additional State:",
        //   updatedStates["additional"].map((a) => a.code)
        // );

        return updatedStates;
      });

      setWarningMessage((prevWarnings) => {
        let updatedWarnings = [...prevWarnings];

        const filteredPrincipalWarnings = newPrincipalWarnings.filter(
          (warning) => !popupWarnings.some((popup) => popup.message === warning)
        );

        const filteredAdditionalWarnings = newAdditionalWarnings.filter(
          (warning) => !popupWarnings.some((popup) => popup.message === warning)
        );

        if (filteredPrincipalWarnings.length > 0) {
          updatedWarnings = [
            filteredPrincipalWarnings[0],
            ...updatedWarnings.filter(
              (w) => w !== filteredPrincipalWarnings[0]
            ),
          ];
        }

        filteredAdditionalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.push(warning);
          }
        });

        return updatedWarnings;
      });

      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...nonDuplicateValidCodes.map(({ code }) => code),
      ]);
      const lastInsertedCode =
        nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1]?.code;
      const popupWarning = popupWarnings.find(
        (w) => w.code === lastInsertedCode
      );

      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.message);
        setModalVisible(true);
      }
    } catch (error) {
      console.error("Error handling drop:", error);
    } finally {
      setIsAnimation(false);
      setAuditedStatus(false);
      const newEpisodeListFilterObj = localStorage.getItem("filters");
      const hcpLineId = localStorage.getItem("last_hcp_line_id");
      dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {
        console.log(res, "drgclickres");

        const newEpisodeRecord = res.payload?.episode?.find(
          (episode) => episode?.hcp_line_id === Number(hcpLineId)
        );

        if (newEpisodeRecord) {
          dispatch(selectedEpisodeList(newEpisodeRecord));
        }
      });
    }
  };
  // const handleCodeAssistAdding = async (draggedData) => {
  //   //console.log('yess............', draggedData);
  //   //console.log(JSON.parse(draggedData), JSON.parse(draggedData), draggedData, 'dfgdf');
  //   setAuditedStatus(true);
  //   setIsAnimation(true);

  //   try {
  //     const parsedData = JSON.parse(draggedData);

  //     // Check if draggedData is in new format
  //     const isNewFormat =
  //       parsedData.hasOwnProperty("Principal Diagnosis") ||
  //       parsedData.hasOwnProperty("Additional Diagnoses") ||
  //       parsedData.hasOwnProperty("Procedure Diagnosis");

  //     if (isNewFormat) {
  //       const sectionMap = {
  //         "Principal Diagnosis": "principal",
  //         "Additional Diagnoses": "additional",
  //         "Procedure Codes": "procedure",
  //       };

  //       for (const [key, type] of Object.entries(sectionMap)) {
  //         const entries = parsedData[key] || [];

  //         for (const entry of entries) {
  //           const codesToInsert = entry.codes || [];

  //           const fakeDraggedData = JSON.stringify({
  //             tab:
  //               type === "principal"
  //                 ? "Principal diagnosis"
  //                 : type === "additional"
  //                 ? "ICD 10 AM Index"
  //                 : "ACHI Tab", // Replace with actual tab name for procedure
  //             codes: codesToInsert,
  //           });

  //           await handleCodeAssistAdding(fakeDraggedData);
  //         }
  //       }

  //       return;
  //     }

  //     let type;

  //     if (parsedData.tab === "ICD 10 AM Index") {
  //       type = "additional";
  //     } else if (parsedData.tab === "Principal diagnosis") {
  //       type = "principal";
  //     } else {
  //       type = "procedure";
  //     }

  //     //console.log(type, 'ppnewr', parsedData);

  //     const { codes, tab } = parsedData;
  //     if (!codes || !Array.isArray(codes) || codes.length === 0) {
  //       toast.error("Invalid codes!");
  //       return;
  //     }

  //     const existingCodes = new Set([
  //       ...diagnosisStates["principal"].map((item) =>
  //         item?.code?.replace(/^[12]/, "")
  //       ),
  //       ...diagnosisStates["additional"].map((item) =>
  //         item?.code?.replace(/^[12]/, "")
  //       ),
  //       ...diagnosisStates["procedure"].map((item) =>
  //         item?.code?.replace(/^[12]/, "")
  //       ),
  //     ]);

  //     const isICD = tab.includes("ICD 10 AM");
  //     const isACHI = tab.includes("ACHI");
  //     if (
  //       (type === "procedure" && isICD) ||
  //       ((type === "additional" || type === "principal") && isACHI)
  //     ) {
  //       toast.warning(
  //         `${
  //           isICD ? "ICD" : "ACHI"
  //         } codes can't be inserted in ${type.toUpperCase()} section`
  //       );
  //       return;
  //     }

  //     let extractedCodesArray = [];
  //     codes.forEach((code) => {
  //       code = code.trim();
  //       if (!code) return;

  //       const match = code.match(/^\(([^)]+)\)(.+)$/);
  //       if (match) {
  //         extractedCodesArray.push(match[2].trim());
  //         extractedCodesArray.push(match[1].trim());
  //       } else {
  //         extractedCodesArray.push(code);
  //       }
  //     });

  //     let principalCode = extractedCodesArray[0];
  //     let additionalCodes = extractedCodesArray.slice(1);
  //     let prevPrincipal = diagnosisStates["principal"][0];
  //     let duplicateCodes = extractedCodesArray.filter((code) =>
  //       existingCodes.has(code.replace(/^[12]/, ""))
  //     );

  //     let uniqueNewCodes = extractedCodesArray.filter(
  //       (code) => !existingCodes.has(code.replace(/^[12]/, ""))
  //     );

  //     if (duplicateCodes.length > 0) {
  //       toast.warning(
  //         `Duplicate code${
  //           duplicateCodes.length > 1 ? "s" : ""
  //         } found: ${duplicateCodes
  //           .map((code) => code.replace(/^[12]/, ""))
  //           .join(", ")}`
  //       );
  //     }

  //     if (uniqueNewCodes.length === 0) {
  //       return; // No new codes to insert
  //     }

  //     let finalValidCodes = [];
  //     let newPrincipalWarnings = [];
  //     let newAdditionalWarnings = [];
  //     let popupWarnings = [];

  //     const validationResults = await Promise.all(
  //       uniqueNewCodes.map(async (extractedCode) => {
  //         const validationType =
  //           extractedCode.replace(/^[12]/, "") ===
  //             principalCode.replace(/^[12]/, "") && type === "principal"
  //             ? "principal"
  //             : type === "procedure"
  //             ? "procedure"
  //             : "additional";

  //         const { valid, description, isWarning, warningDescription, isPopup } =
  //           await validateCodeAPI(extractedCode, validationType);

  //         if (!valid) return null;

  //         const warning = {
  //           is_warning: isWarning,
  //           should_popup: isPopup,
  //           warning_description: warningDescription,
  //         };

  //         if (isWarning && warningDescription) {
  //           if (validationType === "principal") {
  //             newPrincipalWarnings.push(warningDescription);
  //           } else {
  //             newAdditionalWarnings.push(warningDescription);
  //           }
  //         }

  //         if (isPopup) {
  //           popupWarnings.push({
  //             code: extractedCode,
  //             message: warningDescription,
  //           });
  //         }

  //         return { code: extractedCode, description, warning, validationType };
  //       })
  //     );

  //     finalValidCodes = validationResults.filter(Boolean);
  //     if (finalValidCodes.length === 0) {
  //       toast.warning("No valid new codes to insert!");
  //       return;
  //     }

  //     const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
  //       const normalizedCode = code.replace(/^[12]/, "");
  //       if (existingCodes.has(normalizedCode)) {
  //         toast.warning(`Code ${normalizedCode} already exists!`);
  //         return false;
  //       }
  //       return true;
  //     });

  //     if (nonDuplicateValidCodes.length === 0) {
  //       toast.warning("Codes already exist!");
  //       return;
  //     }

  //     await Promise.all(
  //       nonDuplicateValidCodes.map(
  //         ({ code, description, warning, validationType }) =>
  //           insertCode(
  //             validationType !== "procedure"
  //               ? `2${code.replace(/^[12]/, "")}`
  //               : code,
  //             description,
  //             validationType,
  //             warning
  //           )
  //       )
  //     );
  //     setIconDispaly(true);
  //     saveToHistory();
  //     setDiagnosisStates((prevStates) => {
  //       let updatedStates = { ...prevStates };

  //       if (type === "principal") {
  //         const prevPrincipal = prevStates["principal"][0];
  //         const existingAdditional = prevStates["additional"];

  //         // Find the new principal code entry from nonDuplicateValidCodes
  //         const principalEntry = nonDuplicateValidCodes.find(
  //           ({ code }) =>
  //             code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, "")
  //         );

  //         // Codes inside parentheses from dragged data - must come first in additional
  //         const associatedAdditionalCodes = extractedCodesArray.slice(1); // skip first principal

  //         // Build array of additional codes to prepend, filtering duplicates
  //         let additionalToPrepend = [];

  //         // Insert any missing associated additional codes (in order)
  //         associatedAdditionalCodes.forEach((code) => {
  //           // Check if already exists in additional
  //           const normalizedCode = code.replace(/^[12]/, "");
  //           const alreadyInAdditional = existingAdditional.some(
  //             (item) => item.code.replace(/^[12]/, "") === normalizedCode
  //           );

  //           // Also check in nonDuplicateValidCodes for description etc
  //           const foundEntry = nonDuplicateValidCodes.find(
  //             (item) => item.code.replace(/^[12]/, "") === normalizedCode
  //           );

  //           if (!alreadyInAdditional && foundEntry) {
  //             additionalToPrepend.push({
  //               ...foundEntry,
  //               code: `2${foundEntry.code.replace(/^[12]/, "")}`, // normalize code prefix
  //             });
  //           }
  //         });

  //         // Move previous principal to additional if not already there
  //         if (
  //           prevPrincipal &&
  //           !existingAdditional.some(
  //             (item) =>
  //               item.code.replace(/^[12]/, "") ===
  //               prevPrincipal.code.replace(/^[12]/, "")
  //           )
  //         ) {
  //           additionalToPrepend.push({
  //             ...prevPrincipal,
  //             code: `2${prevPrincipal.code.replace(/^[12]/, "")}`,
  //           });

  //           // Insert code for previous principal as additional
  //           insertCode(
  //             `2${prevPrincipal.code.replace(/^[12]/, "")}`,
  //             prevPrincipal.description,
  //             "additional",
  //             prevPrincipal.warning
  //           );
  //         }

  //         // Filter out all prepended additional codes from existing additional to avoid duplicates
  //         const filteredAdditional = existingAdditional.filter(
  //           (item) =>
  //             !additionalToPrepend.some(
  //               (prepended) =>
  //                 prepended.code.replace(/^[12]/, "") ===
  //                 item.code.replace(/^[12]/, "")
  //             )
  //         );

  //         // Set new principal code
  //         if (principalEntry) {
  //           updatedStates["principal"] = [
  //             {
  //               ...principalEntry,
  //               code: `2${principalEntry.code.replace(/^[12]/, "")}`,
  //             },
  //           ];
  //         }

  //         // Prepend additionalToPrepend and then rest of existing additional codes
  //         updatedStates["additional"] = [
  //           ...additionalToPrepend,
  //           ...filteredAdditional,
  //         ];
  //       }

  //       return updatedStates;
  //     });

  //     setWarningMessage((prevWarnings) => {
  //       let updatedWarnings = [...prevWarnings];

  //       const filteredPrincipalWarnings = newPrincipalWarnings.filter(
  //         (warning) => !popupWarnings.some((popup) => popup.message === warning)
  //       );

  //       const filteredAdditionalWarnings = newAdditionalWarnings.filter(
  //         (warning) => !popupWarnings.some((popup) => popup.message === warning)
  //       );

  //       if (filteredPrincipalWarnings.length > 0) {
  //         updatedWarnings = [
  //           filteredPrincipalWarnings[0],
  //           ...updatedWarnings.filter(
  //             (w) => w !== filteredPrincipalWarnings[0]
  //           ),
  //         ];
  //       }

  //       filteredAdditionalWarnings.forEach((warning) => {
  //         if (!updatedWarnings.includes(warning)) {
  //           updatedWarnings.push(warning);
  //         }
  //       });

  //       return updatedWarnings;
  //     });

  //     setNewlyInsertedCodes((prev) => [
  //       ...prev,
  //       ...nonDuplicateValidCodes.map(({ code }) => code),
  //     ]);
  //     const lastInsertedCode =
  //       nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1]?.code;
  //     const popupWarning = popupWarnings.find(
  //       (w) => w.code === lastInsertedCode
  //     );
  //     if (popupWarning) {
  //       setPendingCode(lastInsertedCode);
  //       setPendingType(type);
  //       setModalMessage(popupWarning.message);
  //       setModalVisible(true);
  //     }
  //   } catch (error) {
  //     console.error("Error handling drop:", error);
  //   } finally {
  //     setIsAnimation(false);
  //     setAuditedStatus(false);
  //     fetchData1();
  //     const newEpisodeListFilterObj = localStorage.getItem("filters");
  //     const hcpLineId = localStorage.getItem("last_hcp_line_id");
  //     dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {
  //       console.log(res, "drgclickres");

  //       const newEpisodeRecord = res.payload?.episode?.find(
  //         (episode) => episode?.hcp_line_id === Number(hcpLineId)
  //       );

  //       if (newEpisodeRecord) {
  //         dispatch(selectedEpisodeList(newEpisodeRecord));
  //       }
  //     });
  //   }
  // };

  const handleAcceptCodes = (code) => {
    // toast.success("Code is accepted");
    saveToHistory(); // Important!
    setAcceptedCodes((prev) => ({
      ...prev,
      [code]: true,
    }));
  };

  const normalizeCode = (code) => code?.replace(/^[12]/, ""); // Remove leading 1 or 2
  const handleCofSelect = (type, index, value, code) => {
    const normalizedCode = normalizeCode(code);
    const correctedType = type === "additional" ? "additional_diagnoses" : type;

    // Update selected COF value
    setSelectedCofValues((prev) => {
      const updatedArray = [...(prev[correctedType] || [])];
      const itemIndex = updatedArray.findIndex(
        (item) => normalizeCode(item.code) === normalizedCode
      );

      if (itemIndex !== -1) {
        updatedArray[itemIndex] = { ...updatedArray[itemIndex], cof: value };
      }

      return { ...prev, [correctedType]: updatedArray };
    });

    checkHAC(code).then((res) => {
      const hacExists = res?.data?.code_exists_in_hac ?? res;

      setHACStatus((prev) => {
        const updated = { ...prev };
        String(value) === "2"
          ? delete updated[normalizedCode]
          : (updated[normalizedCode] = hacExists);
        return updated;
      });

      setHasCode(hacExists && String(value) === "1");
      saveToHistory();

      setDiagnosisStates((prev) => {
        if (!prev || typeof prev !== "object") return prev;

        const updated = { ...prev };

        for (const key in updated) {
          if (!Array.isArray(updated[key])) continue;
          updated[key] = updated[key].map((item) =>
            normalizeCode(item.code) === normalizedCode
              ? {
                  ...item,
                  code: `${value}${normalizedCode}`,
                  cof: String(value),
                }
              : item
          );
        }

        handleAccept(null, null, null, updated);
        return JSON.stringify(updated) !== JSON.stringify(prev)
          ? updated
          : prev;
      });
    });
  };

  const handlePopupConfirm = async () => {
    if (!pendingCode || !pendingType) return;
    fetchData1();
    setModalVisible(false);
    setPendingCode("");
    setPendingType("");
  };
  useEffect(() => {
    // Skip if user came from "auditor"
    if (fromLocation === "auditor" || fromLocation === "coder") return;

    const newHcpLineId = episodeListData?.selectedEpisode?.hcp_line_id;
    // console.log(newHcpLineId, episodeListData, 'checkcoding');

    if (
      !newHcpLineId ||
      newHcpLineId === localStorage.getItem("last_hcp_line_id")
    )
      return;

    // setDiagnosisStates({ principal: [], additional: [], procedure: [] });
    setEnteredCode({
      principalCode: "",
      additionalCode: "",
      procedureCode: "",
    });

    localStorage.setItem("last_hcp_line_id", newHcpLineId);
    localStorage.setItem(
      "last_epi_identifier",
      episodeListData?.selectedEpisode?.episode_identifier
    );
    localStorage.setItem(
      "case_mix_speciality",
      episodeListData?.selectedEpisode?.speciality
    );
    localStorage.removeItem("principalDiagnosisState");
    localStorage.removeItem("additionalDiagnosisState");
    localStorage.removeItem("procedureCodesState");
  }, [episodeListData?.selectedEpisode?.hcp_line_id, fromLocation]);
  // console.log(episodeListData, "episodeListDatacoding");

  useEffect(() => {
    localStorage.setItem("diagnosisStates", JSON.stringify(diagnosisStates));
  }, [diagnosisStates]);
  useEffect(() => {
    dispatch(updateAcsCode(null));
    if (lastHcpLineId) {
      setHcpLineId(lastHcpLineId);
    }
  }, [lastHcpLineId]);
  //const lastHcpLineId = localStorage.getItem("last_hcp_line_id");

  useEffect(() => {
    if (drgValue && !skipAcceptApi) {
      handleAccept(null, null, null, diagnosisStates);
    }
    // Ensure principal section exists before checking
    if (diagnosisStates?.principal?.length > 0) {
      const hasHAC = diagnosisStates.principal.some(
        (item) => hacStatus[normalizeCode(item.code)] === true
      );

      setHasPrincipalHAC(hasHAC);
    }
  }, [diagnosisStates, hacStatus]); // Runs on page load and whenever diagnosisStates/hacStatus updates

  const handleDelete = async (type, index) => {
    saveToHistory();
    setDiagnosisStates((prev) => {
      const updatedCodes = [...prev[type]];
      const deletedCode =
        type === "procedure"
          ? updatedCodes[index]?.code?.trim()
          : updatedCodes[index]?.code?.trim().slice(1);

      if (!deletedCode) return prev;

      const allCodes = [
        ...prev.principal,
        ...prev.additional,
        ...prev.procedure,
      ];
      const aiCodes = allCodes.filter((code) => code.origin === "AI");

      // Allow deletion if principal has only one and all codes are AI
      if (type === "principal" && updatedCodes.length === 1) {
        if (aiCodes.length !== allCodes.length) {
          toast.warning("At least one principal code should remain!");
          return prev;
        }

        // Move first additional code to principal
        const additionalCodes = [...prev.additional];
        if (additionalCodes.length === 0) {
          toast.warning("Cannot move additional to principal: none exist.");
          return prev;
        }

        const [firstAdditional, ...remainingAdditional] = additionalCodes;
        const newPrincipal = [firstAdditional];

        const newState = {
          ...prev,
          principal: newPrincipal,
          additional: remainingAdditional,
        };

        // Update HAC status and localStorage
        const normalizedDeletedCode = deletedCode.replace(/^[12]/, "");
        setHACStatus((prevHAC) => {
          if (!prevHAC || typeof prevHAC !== "object") return prevHAC;
          const updatedHAC = { ...prevHAC };
          if (updatedHAC.hasOwnProperty(normalizedDeletedCode)) {
            delete updatedHAC[normalizedDeletedCode];
          }
          return updatedHAC;
        });

        localStorage.setItem(
          "principalDiagnosisState",
          JSON.stringify(newPrincipal)
        );
        localStorage.setItem(
          "additionalDiagnosisState",
          JSON.stringify(remainingAdditional)
        );

        handleAccept(null, null, null, newState);

        setWarningMessage((prevWarnings) => {
          if (!Array.isArray(prevWarnings)) return prevWarnings;
          const normalizedCode = deletedCode.replace(/\./g, "");
          return prevWarnings.filter((w) => {
            const warningCode = w.trim().split(/\s+/)[0].replace(/\./g, "");
            return warningCode !== normalizedCode;
          });
        });

        return newState;
      }

      // Default delete logic
      updatedCodes.splice(index, 1);
      const newState = { ...prev, [type]: updatedCodes };

      setHACStatus((prevHAC) => {
        if (!prevHAC || typeof prevHAC !== "object") return prevHAC;
        const updatedHAC = { ...prevHAC };
        const normalizedCode = deletedCode.replace(/^[12]/, "");
        if (updatedHAC.hasOwnProperty(normalizedCode)) {
          delete updatedHAC[normalizedCode];
        }
        return updatedHAC;
      });

      localStorage.setItem(
        `${type}DiagnosisState`,
        JSON.stringify(updatedCodes)
      );

      handleAccept(null, null, null, newState);

      setWarningMessage((prevWarnings) => {
        if (!Array.isArray(prevWarnings)) return prevWarnings;
        const normalizedDeletedCode = deletedCode.replace(/\./g, "");
        return prevWarnings.filter((w) => {
          const warningCode = w.trim().split(/\s+/)[0].replace(/\./g, "");
          return warningCode !== normalizedDeletedCode;
        });
      });

      return newState;
    });

    setEnteredCode((prev) => ({
      ...prev,
      [type]: "",
    }));
  };

  const handleCodebookClick = (code, codeKey) => {
    // console.log(code, codeKey, "dszfghghdszfg");
    dispatch(setRawSearchQuery(code));
    setCodeBookCard(true);
    setSelectedCodeBookCode(code);
    setSelectedTabKeyCoding(codeKey);
    dispatch(setOnChangeCodeBook(false));
  };
  useEffect(() => {
    const debouncedCalculateDrg = debounce(async () => {
      if (skipAPI) {
        setSkipAPI(false);
        return;
      }

      await calculate_drg(); // This updates drgValue asynchronously
    }, 100);

    debouncedCalculateDrg();

    return () => {
      debouncedCalculateDrg.cancel();
    };
  }, [diagnosisStates]);

  // Call handleAccept **only when drgValue updates**
  useEffect(() => {
    if (drgValue && !skipAcceptApi) {
      //const latestDiag=localStorage.getItem("diagnosisStates")
      //console.log("Updated drgValue:", latestDiag);
      handleAccept(null, null, null, diagnosisStates);
    }
  }, [drgValue]); // Runs **only when drgValue updates**

  function applyDynamicDivHeights(types = []) {
    let totalAvailableHeight = 0;

    // Screen width-based height logic
    if (
      window.matchMedia("(min-width: 1400px) and (max-width: 1599px)").matches
    ) {
      totalAvailableHeight = 250;
    } else if (
      window.matchMedia("(min-width: 1600px) and (max-width: 1750px)").matches
    ) {
      totalAvailableHeight = 290;
    } else if (
      window.matchMedia("(min-width: 1759px) and (max-width: 1919px)").matches
    ) {
      totalAvailableHeight = 430;
    } else if (
      window.matchMedia("(min-width: 1920px) and (max-width: 2099px)").matches
    ) {
      totalAvailableHeight = 440;
    } else if (
      window.matchMedia("(min-width: 2100px) and (max-width: 2200px)").matches
    ) {
      totalAvailableHeight = 530;
    } else if (
      window.matchMedia("(min-width: 2201px) and (max-width: 2559px)").matches
    ) {
      totalAvailableHeight = 590;
    } else if (
      window.matchMedia("(min-width: 2560px)and (max-width: 2900px)").matches
    ) {
      totalAvailableHeight = 765;
    } else if (window.matchMedia("(min-width:2901px)").matches) {
      totalAvailableHeight = 860;
    } else {
      return; // Exit if screen doesn't match any targeted size
    }

    // Step 1: Check for the warning container and adjust totalAvailableHeight
    const warningContainer = document.querySelector(".code-assign-warnings");
    if (
      warningContainer &&
      window.getComputedStyle(warningContainer).display !== "none"
    ) {
      const warningHeight =
        warningContainer.scrollHeight || warningContainer.offsetHeight || 0;
      totalAvailableHeight = Math.max(
        totalAvailableHeight - warningHeight,
        120
      ); // Ensure a minimum height of 100px
    }

    // Step 2: Get content blocks
    const contentBlocks = types
      .map((type) => {
        const el = document.getElementById(`codingscreen-subtitle1-${type}`);
        return {
          type,
          el,
          scrollHeight: el?.scrollHeight || 0,
        };
      })
      .filter(({ el }) => el);

    if (contentBlocks.length === 0) return;

    // Step 3: If total content height is less than available height, fit content naturally
    const totalUsedHeight = contentBlocks.reduce(
      (sum, block) => sum + block.scrollHeight,
      0
    );
    if (totalUsedHeight <= totalAvailableHeight) {
      contentBlocks.forEach(({ el, scrollHeight }) => {
        el.style.maxHeight = `${scrollHeight}px`;
        el.style.overflowY = "visible";
      });
      return;
    }

    // Step 4: Start with equal height allocation
    const equalHeight = Math.floor(totalAvailableHeight / contentBlocks.length);

    // Step 5: First pass - allocate equal heights and check if content fits
    let remainingHeight = totalAvailableHeight;
    const allocatedHeights = contentBlocks.map((block) => {
      const neededHeight = Math.min(block.scrollHeight, equalHeight);
      remainingHeight -= neededHeight;
      return { ...block, allocatedHeight: neededHeight };
    });

    // Step 6: Redistribute remaining height to divs that need more
    const blocksNeedingMore = allocatedHeights.filter(
      (block) => block.allocatedHeight < block.scrollHeight
    );
    if (blocksNeedingMore.length > 0 && remainingHeight > 0) {
      const extraHeightPerBlock = Math.floor(
        remainingHeight / blocksNeedingMore.length
      );
      blocksNeedingMore.forEach((block) => {
        block.allocatedHeight += extraHeightPerBlock;
      });
    }

    // Step 7: Apply final heights and scrolling
    allocatedHeights.forEach(({ el, allocatedHeight, scrollHeight }) => {
      el.style.maxHeight = `${allocatedHeight}px`;
      el.style.overflowY = allocatedHeight < scrollHeight ? "auto" : "visible";
    });
  }
  useEffect(() => {
    const types = ["additional", "procedure"];
    applyDynamicDivHeights(types);

    const onResize = () => applyDynamicDivHeights(types);
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, [diagnosisStates]); // or whatever triggers re-render

  const renderDiagnosisSection = (type, label) => {
    return (
      <>
        <div className={label.replace(/\s+/g, "-").toLowerCase()}>
          <p className="coding-screen-title">{label}</p>
          <div
            id={`codingscreen-subtitle1-${type}`}
            className="codingscreen-subtitle mt-3"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e, type)}
          >
            <Droppable droppableId={type}>
              {(provided) => (
                <div
                  style={{ height: "" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {diagnosisStates[type]?.map((item, index) => (
                    <DraggableItem
                      key={`${type}-${item.code}-${index}`}
                      item={item}
                      type={type}
                      index={index}
                      accepted={acceptedCodes}
                      handleAccept={handleAccept}
                      handleDelete={handleDelete}
                      handleCodebookClick={handleCodebookClick}
                      handleCofSelect={handleCofSelect}
                      selectedCofValues={selectedCofValues}
                      codingscreendata={codingscreendata}
                      iconDisplay={iconDisplay}
                      newlyInsertedCodes={newlyInsertedCodes}
                      handleAcceptCodes={handleAcceptCodes}
                      hacStatus={hacStatus}
                      hasCode={hasCode}
                      drgConfirmedStatusUpdate={drgConfirmedStatusUpdate}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            <div className="input-container">
              <input
                type="text"
                ref={(el) => (inputRefList.current[type] = el)}
                className={`coding-screen-input ${
                  errorMessage[type] ? "error-border" : ""
                }`}
                name={type}
                placeholder={getErrorMessage(errorMessage, type, searchBy)}
                value={enteredCode[type]}
                onChange={(e) => {
                  handleCodeChange(e, type, searchBy);
                  setSearchOptionsDropdown(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleCodeInsertion(e.target.value.toUpperCase(), type);
                    e.preventDefault();
                  }
                }}
                onFocus={() => {
                  setErrorMessage((prev) => ({ ...prev, [type]: "" }));
                  setSearchOptionsDropdown(true);
                  setActiveSection(type);
                  setRecommendations([]);
                  setShowDropdown(false);
                }}
                onBlur={() =>
                  setErrorMessage((prev) => ({ ...prev, [type]: "" }))
                }
              />
              {errorMessage[type] && (
                <span className="error-message">{errorMessage[type]}</span>
              )}
            </div>
          </div>
        </div>
        {activeSection === type && searchOptionsDropdown && !showDropdown && (
          <div
            className={`dropdown reccomendations-dropdown ${type}`}
            ref={searchOptionsRef}
          >
            <div className="reccomendations-items-suggestions">
              <p>Search By...</p>
              <span
                onClick={() => {
                  setSearchBy("Code");
                  setTimeout(() => {
                    inputRefList.current[type]?.focus();
                    setSearchOptionsDropdown(false); // move inside timeout
                  }, 0);
                }}
              >
                Code
              </span>
              <span
                onClick={() => {
                  setSearchBy("Description");
                  setTimeout(() => {
                    inputRefList.current[type]?.focus();
                    setSearchOptionsDropdown(false); // move inside timeout
                  }, 0);
                }}
              >
                Description
              </span>
            </div>
          </div>
        )}
        {activeSection === type && showDropdown && (
          <div
            className={`dropdown reccomendations-dropdown ${type}`}
            ref={dropdownRef}
          >
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              recommendations.codes.map((item, index) => (
                <div
                  className="reccomendations-items"
                  key={index}
                  onClick={() => handleSelectRecommendation(item, type)}
                >
                  <span style={{ color: "#000000" }}>
                    {typeof item?.code === "string" && item.code.includes("(")
                      ? item.code.slice(0, item.code.indexOf("("))
                      : item?.code ?? ""}
                  </span>

                  <span style={{ color: "#252c32" }}>{item.description}</span>
                </div>
              ))
            )}
          </div>
        )}
      </>
    );
  };
  const handleDragEnd = async (result) => {
    setSkipAPI(true);
    const { source, destination } = result;
    if (!destination) {
      setIsAnimation(false);
      return;
    }

    let updatedState;

    await new Promise((resolve) => {
      setDiagnosisStates((prev) => {
        if (!prev) return prev;

        const sourceType = source.droppableId;
        const destinationType = destination.droppableId;

        if (
          (sourceType === "procedure" && destinationType !== "procedure") ||
          (destinationType === "procedure" && sourceType !== "procedure")
        ) {
          toast.warning("Moving items to or from 'Procedure' is not allowed!");
          return prev;
        }

        if (
          sourceType === destinationType &&
          source.index === destination.index
        ) {
          return prev;
        }

        const sourceItems = [...(prev[sourceType] || [])];
        const destinationItems =
          sourceType === destinationType
            ? sourceItems
            : [...(prev[destinationType] || [])];

        const [movedItem] = sourceItems.splice(source.index, 1);
        updatedState = { ...prev };

        if (sourceType === "additional" && destinationType === "principal") {
          if (isCodeRestricted(movedItem.code)) {
            toast.warning(
              `Code is restricted and cannot be added to the Principal section.`
            );
            return prev;
          }

          const previousPrincipal = prev.principal?.[0] || null;
          updatedState = {
            ...prev,
            additional: previousPrincipal
              ? [previousPrincipal, ...sourceItems]
              : sourceItems,
            principal: [movedItem],
          };
          setSkipAPI(false);
        } else if (
          sourceType === "principal" &&
          destinationType === "additional"
        ) {
          const firstAdditional = prev.additional?.[0] || null;
          updatedState = {
            ...prev,
            principal: firstAdditional ? [firstAdditional] : [],
            additional: firstAdditional
              ? [movedItem, ...prev.additional.slice(1)]
              : [movedItem],
          };
          setSkipAPI(false);
        } else {
          destinationItems.splice(destination.index, 0, movedItem);
          updatedState = {
            ...prev,
            [sourceType]: sourceItems,
            [destinationType]: destinationItems,
          };
        }

        const previousWarnings = new Map(
          warningMessage?.map((desc) => [desc, true])
        );
        const updatedWarnings = [
          ...(updatedState.principal || []),
          ...(updatedState.additional || []),
          ...(updatedState.procedure || []),
        ]
          .filter(
            (item) =>
              item?.warning?.is_warning === true &&
              item?.warning?.should_popup === false
          )
          .map((item) => item.warning.warning_description);
        const finalWarnings = Array.from(
          new Set([...updatedWarnings, ...previousWarnings.keys()])
        );
        setWarningMessage(finalWarnings);
        handleAccept(null, null, null, updatedState)
          .then(resolve)
          .catch(() => setIsAnimation(false));
        return updatedState;
      });
      resolve();
    });

    // Now call saveToHistory AFTER diagnosisStates has been updated
    setTimeout(() => {
      saveToHistory(); // Use structuredClone or cloneDeep here
    }, 0);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };
  const handleSelectRecommendation = (selectedValue, type) => {
    console.log(selectedValue, "selval");

    setEnteredCode((prev) => ({
      ...prev,
      [type]: selectedValue.code,
    }));
    setShowDropdown(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideDropdown =
        !dropdownRef.current || !dropdownRef.current.contains(event.target);

      const clickedOutsideSearchOptions =
        !searchOptionsRef.current ||
        !searchOptionsRef.current.contains(event.target);
      const clickedOutsideInputs = !Object.values(inputRefList.current).some(
        (ref) => ref && ref.contains(event.target)
      );

      if (
        clickedOutsideDropdown &&
        clickedOutsideSearchOptions &&
        clickedOutsideInputs
      ) {
        setShowDropdown(false);
        setRecommendations([]);
        setSearchOptionsDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!codingscreendata?.data) return;

    const {
      principal_diagnosis = [],
      additional_diagnoses = [],
      procedure_codes = [],
    } = codingscreendata.data;

    const withCof = (arr) =>
      arr?.map(({ code }) => ({ code, cof: code?.charAt(0) })) || [];

    setSelectedCofValues({
      principal_diagnosis: withCof(principal_diagnosis),
      additional_diagnoses: withCof(additional_diagnoses),
      procedure_codes: withCof(procedure_codes),
    });

    setDiagnosisStates({
      principal: principal_diagnosis,
      additional: additional_diagnoses,
      procedure: procedure_codes,
    });

    localStorage.setItem(
      "principalDiagnosisState",
      JSON.stringify(principal_diagnosis)
    );
    localStorage.setItem(
      "additionalDiagnosisState",
      JSON.stringify(additional_diagnoses)
    );
    localStorage.setItem(
      "procedureCodesState",
      JSON.stringify(procedure_codes)
    );

    const allCodes = [
      ...principal_diagnosis,
      ...additional_diagnoses,
      ...procedure_codes,
    ];
    const newWarnings = allCodes
      .filter((item) => item.warning?.is_warning && !item.warning?.should_popup)
      .map((item) => item.warning.warning_description);
    setWarningMessage(newWarnings.length ? newWarnings : []);

    checkCofWarnings(codingscreendata);
  }, [codingscreendata]);
  return (
    <>
      {
        // isAnimation || isFetchingData1 ? (
        //   <LdsRoller />
        // ) :
        codingscreendata ? (
          <>
            <Warnings
              warningMessage={warningMessage}
              hasPrincipalHAC={hasPrincipalHAC}
            />
            <div
              style={{
                height: "95%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ height: "79%" }} className="coding-screen-wrapper">
                <div
                  className="coding-screen-label-wrapper"
                  style={{ height: "100%" }}
                >
                  <DragDropContext onDragEnd={handleDragEnd}>
                    {renderDiagnosisSection("principal", "Principal diagnosis")}
                    {renderDiagnosisSection(
                      "additional",
                      "Additional diagnoses"
                    )}
                    {renderDiagnosisSection("procedure", "Procedure codes")}
                  </DragDropContext>
                </div>
              </div>
              <div className="second-container">
                <VentilationInfo codingscreendata={codingscreendata} />
                {drgloading ? (
                  <Loader />
                ) : (
                  location.pathname !== "/Code-Assist" &&
                  location.pathname !== "/Auditor-CodeAssist-Screen" &&
                  !isSmallScreen && (
                    <DrgInfo drgData={drgData} setDrgData={setDrgData} drgValue={drgValue} weightValue={weightValue} />
                  )
                )}
                {location.pathname !== "/Code-Assist" &&
                location.pathname !== "/Auditor-CodeAssist-Screen" ? (
                  <div className="codingscreen-btns-wrapper">
                    <button
                      onClick={handleConfirmDrg}
                      className={`confirm-drg-code w-100 ${
                        drgConfirmedStatusUpdate || drgloading
                          ? "disabled"
                          : isButtonEnabled || allOriginsAreU
                          ? "enabled"
                          : "disabled"
                      }`}
                      disabled={
                        drgloading
                          ? true
                          : isDrgConfirmed ||
                            !(isButtonEnabled || allOriginsAreU)
                      }
                    >
                      {drgConfirmedStatusUpdate
                        ? "Confirming..."
                        : "Confirm DRG"}
                      <img
                        src={confirm_tick}
                        alt="confirm"
                        style={{ paddingLeft: "8px", width: "18px" }}
                      />
                    </button>
                    {/* <button className="generate-cdq w-100">
                    Generate CDQ{" "}
                    <img
                      src={generate_cdq}
                      alt="generate"
                      style={{ paddingLeft: "8px", width: "14px" }}
                    />
                  </button> */}
                    <button
                      className="code-assist w-100"
                      onClick={() => {
                        if (location.pathname === "/Auditor-Coding-Screen") {
                          navigate("/Auditor-CodeAssist-Screen");
                        } else {
                          navigate("/Code-Assist");
                        }
                      }}
                    >
                      Code Assist
                      <img
                        src={code_assist}
                        alt="assist"
                        style={{ paddingLeft: "8px", width: "20px" }}
                      />
                    </button>
                  </div>
                ) : (
                  <div className="codeassist-btn-wrapper">
                    <button
                      onClick={() => toast.success("Codes are added")}
                      className="codeassist-finalise"
                      disabled={enableFinalize}
                    >
                      Finalize
                      <img
                        src={confirm_tick}
                        alt="confirm"
                        style={{ paddingLeft: "8px", width: "18px" }}
                      />
                    </button>
                    <button
                      className="ai-search"
                      onClick={async () => {
                        const toastId = toast.loading("Initializing search...");
                        try {
                          await fetchData1();
                          //Toast will be automatically updated or removed when fetch completes
                          toast.update(toastId, {
                            render: "You are ready",
                            type: "success",
                            isLoading: false,
                            autoClose: 1000,
                          });
                          setShowCodeSearch(true);
                        } catch (error) {
                          toast.update(toastId, {
                            render: "Search failed!",
                            type: "error",
                            isLoading: false,
                            autoClose: 3000,
                          });
                        } finally {
                          setIsLoading(false);
                        }
                      }}
                    >
                      Code Search
                      <img
                        src={code_assist_seacrh}
                        alt="search"
                        style={{ paddingLeft: "8px", width: "22px" }}
                      />
                    </button>
                    <button className="ai-search">
                      AI Assist
                      <img
                        src={stars_icon}
                        alt="magic"
                        style={{ paddingLeft: "8px", width: "22px" }}
                      />
                    </button>
                  </div>
                )}
              </div>
            </div>
            {modalVisible && (
              <WarningModal
                modalMessage={modalMessage}
                handleModalClose={handleModalClose}
                handlePopupConfirm={handlePopupConfirm}
              />
            )}
          </>
        ) : (
          <p className="m-auto">No data found</p>
        )
      }
    </>
  );
};
export default CodingScreen;
